import {configureStore} from '@reduxjs/toolkit'
import {setupListeners} from '@reduxjs/toolkit/query'
import {authApi} from './api/services/auth'
import {batchApi} from './api/services/batch'
import authSlice from './slices/authSlice'
import batchDetailsSlice from './slices/batchDetailsSlice'
import completedBatchFilterSlice from './slices/completedBatchFilterSlice'
import {rtkQueryErrorLogger} from './middlwares/rtkQueryErrorLogger'
import infoReducer from './slices/infoSlice'
import userFilterSlice from './slices/userFilterSlice'
import {userApi} from './api/services/user'
import messageReducer from './slices/messageSlice'
import {profile} from './api/services/profile'

export const store = configureStore({
  reducer: {
    info: infoReducer,
    authSlice: authSlice,
    batchDetailsSlice: batchDetailsSlice,
    completedBatchFilterSlice: completedBatchFilterSlice,
    userFilterSlice: userFilterSlice,
    messageRedux: messageReducer,
    [authApi.reducerPath]: authApi.reducer,
    [batchApi.reducerPath]: batchApi.reducer,
    [userApi.reducerPath]: userApi.reducer,
    [profile.reducerPath]: profile.reducer,
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware()
      .concat(authApi.middleware)
      .concat(batchApi.middleware)
      .concat(userApi.middleware)
      .concat(profile.middleware)
      .concat(rtkQueryErrorLogger),
})

// Infer the `RootState` and `AppDispatch` types from the store itself
export type RootState = ReturnType<typeof store.getState>
// Inferred type: {posts: PostsState, comments: CommentsState, users: UsersState}
export type AppDispatch = typeof store.dispatch

setupListeners(store.dispatch)
